<template>
  <div>
    <Wrapper>
      <Sidebar slot="sidebar"/>
      <Navbar slot="navbar"/>
      <Footer slot="footer"/>
      <div slot="content" >

        <!-- <input type="text" v-model="filters.name.value"> -->
        <div class="pt-1">
          <div class="row">
            <div class="col-md-3 col-1" v-if="windowWidth > 767">
              <button
                class="pl-1"
                style="background:#fff; border-radius: 5px; min-height: 35px; border: 1px solid #FAF0F0;"
                @click="goHome"
              >
                <img src="../../../assets/images/left_arrow.png" class="mb-1" height="12"> Home
              </button>
            </div>
            <div class="col-md-6 col-12 text-center">
              <div style="min-width:100%; display:flex; justify-content:center">
                <div
                  class="tab-div"
                  style="display:flex; justify-content:center;  align-items:center; max-width:400px; min-height:60px"
                >
                  <div
                    style="flex-basis:50%;  border-bottom:1px solid #0094FF"
                    class="pb-2 point-cursor"
                  >
                    <p>Vestlock</p>
                  </div>
                  <div style="flex-basis:50%" class="pb-2 point-cursor">
                    <p @click="gotoVestPortfolio">Vestlock Portfolio</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-1 text-right" v-if="windowWidth > 767">
              <!-- 
                <img src="../../../assets/images/cancel2.png"
                style="cursor:pointer; padding-right:30px"
              >-->
            </div>
          </div>
        </div>

        <div class="container">
          <div>
            <div class="text-center mt-4 mb-4">
              <p>Wallet Balance</p>
              <h4 class="pt-2">
                <span>&#8358;</span>
                {{formatAmount(userBal)}}
              </h4>
            </div>

            <div style="min-height:40vh; display:flex; justify-content:center; align-items:center">
              <div style="min-width:100%">
                <div class="text-left input-div">
                  <p class="mb-3" v-if="windowWidth > 455">Provide investment details</p>
                  <img
                    src="../../../assets/images/amount.png"
                    height="120"
                    class="mb-3"
                    v-if="windowWidth < 455"
                  >
                  <div style="position:relative;">
                    <!-- <img src="../../../assets/images/cash.png" height="30" > -->
                    <input
                      type="text"
                      class="vest-input"
                      autofocus
                      @keydown.enter.prevent="gotoSummary"
                      @keyup="getFundValue"
                      :value="returnMinAmount"
                      style="min-width:100%"
                      placeholder="Amount"
                    >

                    <div class="mt-3">
                      <select
                        @change="getProductSelected($event)"
                   
                        style="border:1px solid  #0094FF; border-radius:5px; padding:10px; background:#fff"
                      >
                        <option
                          v-for="prod in vestLockProducts"
                          :value="prod.id"
                          :key="prod.id"
                      :selected="prod.id == firstVestProductId"
                        
                        >
                          <span v-if="prod.fixed_tenor > 1">{{prod.fixed_tenor}} months</span>  <span v-else>{{prod.fixed_tenor}} month</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -- 
                          <span>{{prod.calcRoi}}%</span>
                        </option>
                      </select>
                    </div>
                    <div
                      class="text-center mt-3 tran-height point-cursor"
                      :class="{'tran-show-height':showError}"
                    >
                      <img
                        src="../../../assets/images/error-vest.png"
                        height="35"
                        @click="sendToWallet"
                      >
                    </div>
                    <div>
                      <button
                        class="vest-btn-2"
                        @click="gotoSummary"
                        style="min-width:100%"
                        :class="{'fade-elem':amountIsNotEnough}"
                      >
                        <i class="fa fa-spin fa-spinner" v-if="vestLoader"></i>
                        {{ vestLoader ? '':'Continue' }}
                      </button>
                    </div>
                    <img
                      src="../../../assets/images/back3.png"
                      v-if="windowWidth < 455"
                      @click="goHome"
                      class="mt-4"
                      height="35"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  </div>
</template>

<script>
import Navbar from "../../partials/Navbar";
import Sidebar from "../../partials/Sidebar";
import Footer from "../../partials/Footer";
import Wrapper from "../../partials/Wrapper";
import trans from "../../../../translations";

import { commonJs } from "../mixins/commonJs.js";

import { mapState } from "vuex";

import moment from "moment";

export default {
  mixins: [commonJs],
  data() {
    return {
      tran: {},
      amountError: false,
      amountIsNotEnough: true,
      minAmount: "",
      showError: false,
      apiData: "",
      prodSelected:false
    };
  },
  methods: {
    goHome() {
      this.$router.push("/vest/home");
      this.$store.commit("auth/saveVestRouteVisited", "/vest/home");
    },

    gotoVestPortfolio() {
      this.$router.push("/vest/portfolio");
      this.$store.commit("auth/saveVestRouteVisited", "/vest/portfolio");
    },
    gotoInitInvestment() {
      this.$router.push("/vest/portfolio");
      this.$store.commit("auth/saveVestRouteVisited", "/vest/portfolio");
    },

    getVestLockProduct() {
      let apiData = {
        amount: 1200
      };

      this.$store.dispatch("market/getVestLockProducts", apiData);
    },
    gotoSummary() {
   
   if(this.prodSelected == false){

     let product = this.vestLockProducts.filter(prod => {
       return this.firstVestProductId == prod.id;
     });
      this.$store.commit("market/saveVestLockInvestmentData", product[0]);
   }
      this.$store.dispatch("market/getSelectedVestLockProduct", this.amount);
    },

    getProductSelected(e) {
      this.$helpers.log(e.target.value);
      this.prodSelected = true
      let product = this.vestLockProducts.filter(prod => {
        return e.target.value == prod.id;
      });

      this.$helpers.log(product, "selected product");
      this.$store.commit("market/saveVestLockInvestmentData", product[0]);
    },

    sendToWallet() {
      this.$router.push({ path: "/wallet", query: { openFundWallet: true, fundAmount:this.amount } });
    },

  getFundValue(e) {
      let fundValue = e.target.value;
      e.target.value = parseInt(
        fundValue.replace(/\D/g, ""),
        10
      ).toLocaleString();

      this.minAmount = e.target.value;

      let inputValue = this.minAmount.toString().replace(/,/g, "");

      if (isNaN(this.minAmount.toString().replace(/,/g, ""))) {
        this.minAmount = "";
      }
      this.$helpers.log(inputValue, "value of input");

      this.amount = inputValue;

      if (
        inputValue >= 1000 &&
        parseFloat(this.userBal) >= parseFloat(inputValue)
      ) {
        this.amountIsNotEnough = false;
        this.showError = false;
      } else if (
        inputValue >= 1000 &&
        parseFloat(this.userBal) <= parseFloat(inputValue) 
      ) {
        this.amountIsNotEnough = true;
        this.showError = true;
      } else {
        this.amountIsNotEnough = true;
      }
    }
  },
  components: {
    Navbar,
    Footer,
    Sidebar,
    Wrapper
  },

  computed: {
    ...mapState({
      userBal: state => state.auth.userProfileInfo.balance,
      vestLoader: state => state.market.vestLoader,
      vestAmount: state => state.market.vestAmount,
      vestLockProducts: state => state.market.vestLockProducts,
      firstVestProductId: state => state.market.firstVestProductId,
    }),

    returnAmountOfPenalty() {
      return this.penaltyAmount;
    },

    returnMinAmount() {
      return this.minAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted() {
    let heading = {
      main: this.tran.vest_lock
    };
    this.$store.commit(
      "auth/saveVestRouteVisitedAfterClickingPortfolio",
      this.$route.path
    );
    this.$store.commit("market/savePageHeading", heading);
    this.getVestLockProduct();


  },

  beforeCreate() {
    this.$store.dispatch("market/getPortfolio");
    this.$store.commit("market/checkSearchObject", "portfolio");
  },

  beforeDestroy() {
    this.$store.commit("market/startPreloader");
  }
};
</script>

<style scoped>
.fade-elem {
  background: #fff;
  border: 2px solid #e0e0e0;
  opacity: 0.3;
}

.input-div {
  margin: 0 auto;
}

@media (min-width: 1400px) {
  .input-div {
    max-width: 20vw;
  }
}

@media (max-width: 1300px) {
  .input-div {
    max-width: 26vw;
  }
} 

@media (max-width: 991px) {
  .input-div {
    max-width: 50vw;
  }
}

@media (max-width: 445px) {
  .input-div {
    max-width: 90vw;
  }
}

</style>
